import { Input, ModalProps } from 'antd'
import { KeyboardEvent, useEffect, useState, useRef } from 'react'
import OverrideValueModalBase from './OverrideValueModalBase'
import * as Model from './overrideValue'

export type Props = {
  visible: boolean
  label: string
  name: string
  currentValue?: string
  defaultValue: string
  onCancel: () => void
  onSubmit: (value: string) => void
  onReset: () => void
  maxLength?: number
} & Pick<ModalProps, 'getContainer'>

export default function OverrideStringValueModal({
  visible,
  currentValue,
  defaultValue,
  label,
  name,
  onCancel,
  onSubmit,
  onReset,
  maxLength,
  getContainer
}: Props) {
  const [value, setValue] = useState<string>(Model.getStringValue(defaultValue, currentValue))
  useEffect(() => {
    setValue(Model.getStringValue(defaultValue, currentValue))
    if (visible && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus()
        inputRef.current.select()
      }, 100)
    }
  }, [visible])

  const inputRef = useRef<any>()

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.code === 'Enter') {
      onSubmit(Model.submitString(value))
    }
    if (e.code === 'Escape') {
      onCancel()
    }
  }

  const input = <Input
    style={{ width: '100%' }}
    value={value ?? ''}
    onChange={e => setValue(e.target.value)}
    onKeyDown={onKeyDown}
    ref={inputRef}
    maxLength={maxLength}
  />

  return <OverrideValueModalBase
    visible={visible}
    label={label}
    name={name}
    defaultValue={`${defaultValue}`}
    input={input}
    onCancel={onCancel}
    onSubmit={() => onSubmit(Model.submitString(value))}
    onReset={onReset}
    showReset={Model.shouldShowStringReset(defaultValue, value)}
    getContainer={getContainer}
  />
}
